export const zofiaKurowska = {
    'mydrId': 'zofiakurowska',
    'firstName': 'Zofia',
    'lastName': 'Kurowska',
    'profession': 'Psycholog, pedagog, terapeuta',
    'avatar': 'zofia-kurowska.webp',
    'slug': 'psycholog-pedagog-zofia-kurowska',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychology', 'consultation'],
    ]
}